<template>
  <v-container fluid grid-list-sm class="header-container">
    <v-layout row wrap>
      <v-flex xs12 pa-3 class="header-content text-xs-center white--text headline font-weight-medium">
        Timesheet Approvals
      </v-flex>

      <v-container fluid grid-list-sm>
        <v-flex xs12 v-for="(link, i) in links" :key="i" pa-2>
          <v-card class="elevation-2" v-if="(link.requiresAdmin && userProfile.IsAdmin) || !link.requiresAdmin" >
            
            <v-list two-line class="pa-0">
              <v-list-tile
                avatar
                :to="link.to"
              >

                <v-list-tile-action class="text-xs-center">
                  <v-avatar size="50" style="border: 1px solid red" :color="link.color">
                    <v-icon size="25" color="white"> 
                      {{link.icon}}
                    </v-icon>
                  </v-avatar>
                </v-list-tile-action>
                

                <v-list-tile-content class="pl-2" >
                  <v-list-tile-title class="title">{{link.title}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{link.text}}</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-avatar>
                    <v-icon size="70"> 
                      mdi-chevron-right
                    </v-icon>
                  </v-avatar>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import {
  mapMutations,
  mapState
} from 'vuex'
export default {
  computed: {
    ...mapState('app', ['userProfile']),
  },
  data: () => ({
    links: [
      {
        to: '/timesheetApproval/submitTimesheets',
        icon: 'mdi-send',
        title: 'Submit Timesheets',
        text: 'Submit timesheets for approval',
        color: '#334444'
      },
      {
        to: '/timesheetApproval/viewSubmissions',
        icon: 'mdi-send',
        title: 'Submit Timesheets for others',
        text: 'View and submit timesheets for approval for other employees',
        color: '#334499',
        requiresAdmin: true
      },
      {
        to: '/timesheetApproval/approvalList',
        icon: 'mdi-account-multiple-check',
        title: 'Approve Timesheets',
        text: 'Approve or rejects timesheets assigned to you',
        color: '#4BD370'
      },
      // {
      //   to: '/timesheetApproval/viewApprovalLists',
      //   icon: 'mdi-account-multiple-check',
      //   title: 'Approve Timesheets for others',
      //   text: 'View and approve timesheets for other managers',
      //   color: '#4BD3FF',
      //   requiresAdmin: true
      // }
    ]
  })

}
</script>

<style>

</style>
